export const KPI_ACCENT = '#6E368C';

export const KPI_COLORS = ['#6E368C', '#9B6BB8', '#1565C0', '#2E7D32', '#ED6C02', '#C62828', '#00838F', '#6A1B9A'];

export const pickLayout = (layout = {}, fallback = {}) => ({
    xs: layout.xs ?? fallback.xs ?? 12,
    sm: layout.sm ?? fallback.sm ?? layout.xs ?? 12,
    md: layout.md ?? fallback.md ?? 12,
    lg: layout.lg ?? layout.md ?? fallback.md ?? 12,
    height: layout.height ?? fallback.height ?? 320
});

export const formatKpiValue = (value, format = 'number', config = {}) => {
    if (value === null || value === undefined || value === '') {
        return '—';
    }
    const number = Number(value);
    if (Number.isNaN(number)) {
        return String(value);
    }

    if (format === 'percent') {
        return `${number.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;
    }
    if (format === 'currency') {
        return number.toLocaleString('pt-BR', {
            style: 'currency',
            currency: config.currency || 'BRL'
        });
    }

    return number.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
};

export const rowValue = (row, key, fallbackKeys = []) => {
    if (!row) {
        return null;
    }
    if (key && row[key] !== undefined && row[key] !== null) {
        return row[key];
    }
    const found = fallbackKeys.find((item) => row[item] !== undefined && row[item] !== null);
    return found ? row[found] : null;
};

export const canAccessKpiMenu = (user = {}) => {
    const perfil = parseInt(user.perfil_id, 10);
    const supervisor = parseInt(user.supervisor, 10);
    return perfil === 1 || (perfil === 3 && supervisor === 1);
};
